import { Document, DocumentFormValues } from '../../model';

export function formatDocumentToApiDocument(
  doc: DocumentFormValues,
  type: string
): Document {
  return { documentId: doc.documentId, type, fileName: doc.fileName };
}
